import type { Tool, ToolContext, PointerInfo } from "./Tool";

/**
 * Click-to-select. Plain click replaces the selection; Shift-click toggles
 * the clicked tube into a multi-selection. Clicking empty space clears.
 */
export class SelectTool implements Tool {
  readonly id = "select";
  readonly name = "Select";
  readonly hint = "Click a tube to select. Shift-click to select multiple.";
  readonly icon = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 3l8 19 3-8 8-3z" />
    </svg>`;

  onPointerDown(info: PointerInfo, ctx: ToolContext): void {
    const hits = info.raycaster.intersectObjects(ctx.design.root.children, true);
    const tubeHit = hits.find((h) => !!ctx.design.findByObject(h.object));
    const tube = tubeHit ? ctx.design.findByObject(tubeHit.object) ?? null : null;

    if (info.event.shiftKey && tube) {
      ctx.toggleSelection(tube);
    } else {
      ctx.setSelection(tube);
    }
  }
}
